import { createFileRoute, redirect } from '@tanstack/react-router';

// The feature lives on a tab of the bonus hub; this URL stays for old links.
export const Route = createFileRoute('/_player/referral')({
  beforeLoad: () => {
    throw redirect({ to: '/promos', search: { tab: 'referral' } });
  },
});
